module.exports = __webpack_public_path__ + "img/client14.c95ccadd.png";